// extracted by mini-css-extract-plugin
export default {"background":"styles_background__fhM2h","logo":"styles_logo__cls7M"};